import React from "react";
import { CircularProgress } from "../../primitives";

export default function ERPSLoadingIcon(props) {
  const { className, size = 30 } = props;
  return <CircularProgress size={size} className={className} disableShrink />;
}
